/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MedicareConditionsServices } from './MedicareConditionsServices';
import {
    MedicareConditionsServicesFromJSON,
    MedicareConditionsServicesFromJSONTyped,
    MedicareConditionsServicesToJSON,
} from './MedicareConditionsServices';

/**
 * 
 * @export
 * @interface NtaConditionEvidence
 */
export interface NtaConditionEvidence {
    /**
     * 
     * @type {MedicareConditionsServices}
     * @memberof NtaConditionEvidence
     */
    condition: MedicareConditionsServices;
    /**
     * 1=Found (clear evidence), 2=Maybe (needs confirmation), 3=Not found
     * @type {string}
     * @memberof NtaConditionEvidence
     */
    evidence_rating: NtaConditionEvidenceEvidenceRatingEnum;
    /**
     * 
     * @type {string}
     * @memberof NtaConditionEvidence
     */
    rationale: string;
}


/**
 * @export
 */
export const NtaConditionEvidenceEvidenceRatingEnum = {
    Found: 'found',
    Maybe: 'maybe',
    Not_found: 'not_found'
} as const;
export type NtaConditionEvidenceEvidenceRatingEnum = typeof NtaConditionEvidenceEvidenceRatingEnum[keyof typeof NtaConditionEvidenceEvidenceRatingEnum];


/**
 * Check if a given object implements the NtaConditionEvidence interface.
 */
export function instanceOfNtaConditionEvidence(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "condition" in value;
    isInstance = isInstance && "evidence_rating" in value;
    isInstance = isInstance && "rationale" in value;

    return isInstance;
}

export function NtaConditionEvidenceFromJSON(json: any): NtaConditionEvidence {
    return NtaConditionEvidenceFromJSONTyped(json, false);
}

export function NtaConditionEvidenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): NtaConditionEvidence {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'condition': MedicareConditionsServicesFromJSON(json['condition']),
        'evidence_rating': json['evidence_rating'],
        'rationale': json['rationale'],
    };
}

export function NtaConditionEvidenceToJSON(value?: NtaConditionEvidence | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'condition': MedicareConditionsServicesToJSON(value.condition),
        'evidence_rating': value.evidence_rating,
        'rationale': value.rationale,
    };
}

